import AUTH from '@/api/auth';
import store from '@/store';


// initial state
const state = {
  user: null,
  isLoggedIn: false,
  hasAgilityAccess: false,
  hasBackupAccess: false,
  hasDirectorAccess: false,
  hasSignedAdditionalContract: false,
  viewingAgilityPages: false,
  viewingDirectorPages: false,
  viewingInvoices: false,
  viewingBackupsDevices: false,
  viewingBackupsActivity: false
};

// getters
const getters = {

  user(state) {
    return state.user;
  },

  hasAgilityAccess(state) {
    return state.hasAgilityAccess;
  },

  hasBackupAccess(state) {
    return state.hasBackupAccess;
  },

  hasDirectorAccess(state) {
    return state.hasDirectorAccess;
  },

  hasSignedAdditionalContract(state) {
    return state.hasSignedAdditionalContract;
  },

  isLoggedIn(state) {
    return state.isLoggedIn;
  },

  viewingAgilityPages(state) {
    return state.viewingAgilityPages
  },

  viewingDirectorPages(state) {
    return state.viewingDirectorPages
  },

  viewingInvoices(state) {
    return state.viewingInvoices
  },

  viewingBackupsDevices(state) {
    return state.viewingBackupsDevices
  },

  viewingBackupsActivity(state) {
    return state.viewingBackupsActivity
  }
};

// actions
const actions = {

  login({ commit }, userForm) {
    return new Promise((resolve, reject) => {
      AUTH.login(userForm).then(
        (res) => {
          commit('user', res.data);
          commit('hasAgilityAccess', res.data);
          commit('hasBackupAccess', res.data);
          commit('hasDirectorAccess', res.data);
          commit('hasSignedAdditionalContract', res.data);
          commit('viewingAgilityPages', res.data);
          commit('viewingDirectorPages', res.data);
          commit('viewingInvoices', res.data);
          commit('viewingBackupsDevices', res.data);
          commit('viewingBackupsActivity', res.data);
          resolve();
        }, (err) => {
          reject(err);
        },
      );
    });
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      AUTH.logout().then(
        () => {
          commit('user', null);
          resolve();
        }, (err) => {
          reject(err);
        },
      );
    });
  },

  me({ commit, state }) {
    return new Promise((resolve, reject) => {
      AUTH.me().then(
        (res) => {
          commit('user', res.data);
          commit('hasAgilityAccess', res.data);
          commit('hasBackupAccess', res.data);
          commit('hasDirectorAccess', res.data);
          commit('hasSignedAdditionalContract', res.data);
          commit('viewingAgilityPages', res.data);
          commit('viewingDirectorPages', res.data);
          commit('viewingInvoices', res.data);
          commit('viewingBackupsDevices', res.data);
          commit('viewingBackupsActivity', res.data);

          store.dispatch('contents/setContents').then(() => {
            resolve();
          });
        }, (err) => {
          reject(err);
        },
      );
    });
  },

};

// mutations
const mutations = {

  user(state, user) {
    state.user = user;
    state.isLoggedIn = (user !== null);
  },

  hasAgilityAccess(state, user) {
    state.hasAgilityAccess = (user) ? user.company_obj.has_agility_access : false;
  },

  hasBackupAccess(state, user) {
    state.hasBackupAccess = (user) ? user.company_obj.has_backup_access : false;
  },

  hasDirectorAccess(state, user) {
    state.hasDirectorAccess = (user) ? user.company_obj.has_director_access : false;
  },

  hasSignedAdditionalContract(state, user) {
    state.hasSignedAdditionalContract = (user) ? user.company_obj.has_signed_additional_contract : false;
  },

  viewingAgilityPages(state, user) {
    if (user.is_admin || user.roles_obj.some(role => role.viewing_agility_pages)) {
      state.viewingAgilityPages = true
    } else {
      state.viewingAgilityPages = false
    }
  },

  viewingDirectorPages(state, user) {
    if (user.is_admin || user.roles_obj.some(role => role.viewing_director_pages)) {
      state.viewingDirectorPages = true
    } else {
      state.viewingDirectorPages = false
    }
  },

  viewingInvoices(state, user) {
    if (user.is_admin || user.roles_obj.some(role => role.viewing_invoices)) {
      state.viewingInvoices = true
    } else {
      state.viewingInvoices = false
    }
  },

  viewingBackupsDevices(state, user) {
    if (user.is_admin || user.roles_obj.some(role => role.viewing_backups_devices)) {
      state.viewingBackupsDevices = true
    } else {
      state.viewingBackupsDevices = false
    }
  },

  viewingBackupsActivity(state, user) {
    if (user.is_admin || user.roles_obj.some(role => role.viewing_backups_activity)) {
      state.viewingBackupsActivity = true
    } else {
      state.viewingBackupsActivity = false
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
